export default "__VITE_ASSET__CePaYk_F__"